import requests from "./httpService";
const TaskServices = {
  getAllTask(id, params = {}) {
    const { skipTasks } = params;
    let url = `/tasks/all?company_id=${id}`;
    if (skipTasks) url += `&skipTasks=true`;
    return requests.get(url);
  },
  getDueTodayTask(id) {
    return requests.get(`/tasks/duetoday?company_id=${id}`);
  },
  getTasksByFilter(id, filter) {
    return requests.get(`/tasks/filter?company_id=${id}&filter=${filter}`);
  },
  updateTasksTitle(id, body) {
    return requests.post(`/update-task-title/${id}`, body);
  },
  updateTaskAssigne(id, body) {
    return requests.post(`/tasks/updateasignedto/${id}`, body);
  },
  updateTaskStatus(id, body) {
    return requests.post(`/tasks/updatetaskstatus/${id}`, body);
  },
  createTask(body) {
    return requests.post(`/tasks/create`, body);
  },
  updateTask(id, body) {
    return requests.post(`/tasks/update/${id}`, body);
  },
  viewTask(id, body) {
    return requests.post(`/tasks/view/${id}`, body);
  },
  delTask(id, body) {
    return requests.delete(`/tasks/${id}`, body);
  },
  addTaskNote(id, body, headers) {
    return requests.post(`/tasks/addnote/${id}`, body, headers);
  },
  showTaskNote(id, body) {
    return requests.post(`/tasks/showtasknote/${id}`, body);
  },
  createSubTask(id, body) {
    return requests.post(`/tasks/createsubtask/${id}`, body);
  },
  pinToTop(id, body) {
    return requests.post(`/tasks/updatenotepin/${id}`, body);
  },
  noteUpdate(id, body) {
    return requests.post(`/tasks/updatenote/${id}`, body);
  },
  deleteTask(id, body) {
    return requests.get(`/tasks/${id}`, body);
  },
  deleteTaskNote(id, body) {
    return requests.post(`/tasks/deletenote/${id}`, body);
  },
  createTaskAttatchment(id, body, headers) {
    return requests.post(`/tasks/attachments/${id}`, body, headers);
  },
  updateTaskDueDate(id, body) {
    return requests.post(`/tasks/updatetaskduedate/${id}`, body);
  },

  deleteTaskAttachment(id, body) {
    return requests.post(`/tasks/attachmentdelete/${id}`, body);
  },
  updateNoteReaction(id, body) {
    return requests.post(`/tasks/updatenotereaction/${id}`, body);
  },
  updateTaskProject(id, body) {
    return requests.post(`/tasks/updatetaskproject/${id}`, body);
  },

};
export default TaskServices;
